import { useUpcomingClaims } from '@gik/api/users/claims';
import type { IUserProfileClaim } from '@gik/calendar/models/Claim';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { LoadingSpinner } from '@gik/ui-legacy/LoadingSpinner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ClaimsList from './ClaimsList';
import ClaimsListSkeleton from './ClaimsListSkeleton';
import { translationKeys } from './i18n/en';

export interface IUpcomingClaimsListProps {
  items?: IUserProfileClaim[];
}

const blockName = 'claimed-items-list';

function UpcomingClaimsListComp({ items }: IUpcomingClaimsListProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  const userStore = useUserStore();
  const { data: claims, error: claimsError } = useUpcomingClaims(userStore.id, {
    fallbackData: items,
  });

  const isLoading = !claims;
  const isError = isLoading && claimsError;

  if (isLoading) return <LoadingSpinner center />;
  if (isError) return <LoadingSpinner center />;

  return (
    <ClaimsList className={bem()} items={claims} loading={!claims} emptyText={t(translationKeys.emptyUpcomingClaims)} />
  );
}

export const UpcomingClaimsList = withComponentErrorBoundary(withSuspense(UpcomingClaimsListComp, ClaimsListSkeleton));
